import AppCard from 'presentation/components/shared/card/AppCard';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import HtmlText from 'presentation/components/shared/HtmlText/HtmlText';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  description: string;
}

const StrategyAboutCard: FC<Props> = ({ description }) => {
  const { t } = useTranslation();

  return (
    <>
      <GridHeading>{t('aboutStrategy')}</GridHeading>
      <AppCard p="20px">
        <HtmlText text={description}/>
      </AppCard>
    </>
  );
};

export default StrategyAboutCard;
